import canvasConfetti from "canvas-confetti";

export const fireConfetti = () => {
  var count = 200;
  var defaults = {
    origin: { y: 0.7 },
    colors: ["#eb8154", "#003200", "#ffffff", "#6CAED4"],
  };

  const firePart = (particleRatio, opts) => {
    canvasConfetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
      })
    );
  };

  firePart(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  firePart(0.2, {
    spread: 60,
  });
  firePart(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  firePart(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  firePart(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};
